import React, { useState } from 'react'
import { PropTypes } from 'prop-types'
import { StyleSheet, css } from 'aphrodite'
import IconEye from '../Icon/IconEye'
import IconEyeOff from '../Icon/IconEyeOff'
import {
  COLOR_WHITE,
  COLOR_GRAY__800,
  COLOR_GRAY__600,
  COLOR_ERROR,
  COLOR_MUTED,
  COLOR_GREY_050,
} from '../../lib/colors'
import UIInputError from './UIInputError'

const UIPassword = React.forwardRef(function UIPassword(
  {
    label,
    placeholder,
    value,
    errorMessage,
    message,
    onChange,
    dynamicStyle,
    ...props
  },
  ref
) {
  const [passwordType, setPasswordType] = useState('password')

  const isInError = !!errorMessage
  const hasMessage = !!message
  const handleChange = (event) => {
    onChange(event.target.value)
  }

  return (
    <div className={css(dynamicStyle && dynamicStyle)}>
      {!!label && (
        <>
          <span className={css(styles.label)}>{label}</span>
          <br />
        </>
      )}
      <div className={css(styles.container, isInError && styles.inputError)}>
        <input
          type={passwordType}
          className={css(styles.input)}
          placeholder={placeholder}
          ref={ref}
          {...props}
          value={value}
          onChange={handleChange}
        />
        <div
          className={css(styles.icon)}
          onClick={() =>
            setPasswordType((prev) =>
              prev === 'password' ? 'text' : 'password'
            )
          }
        >
          {passwordType === 'password' ? (
            <IconEyeOff type="button">Toggle password</IconEyeOff>
          ) : (
            <IconEye type="button">Toggle password</IconEye>
          )}
        </div>
      </div>
      {hasMessage && (
        <>
          <span className={css(styles.message)}>{message}</span>
        </>
      )}
      {isInError && (
        <>
          <UIInputError errorMessage={errorMessage} />
        </>
      )}
    </div>
  )
})

const styles = StyleSheet.create({
  container: {
    width: '100%',
    borderRadius: 5,
    backgroundColor: COLOR_WHITE,
    display: 'flex',
    alignItems: 'center',
    gap: '5px',
  },
  inputError: {
    border: '1px solid',
    borderColor: COLOR_ERROR,
    color: COLOR_ERROR,
  },
  icon: {
    cursor: 'pointer',
  },
  input: {
    width: '100%',
    padding: '14px 16px',
    margin: '10px 0',
    borderRadius: 5,
    border: '1px solid transparent',
    backgroundColor: COLOR_GREY_050,
    boxShadow: '0 1px 2px 0 #32324733',
    fontWeight: 500,
    fontSize: 15,
    color: COLOR_GRAY__800,
  },
  message: {
    fontWeight: 400,
    fontSize: 11,
    color: COLOR_MUTED,
    display: 'block',
    marginTop: '8px',
  },
  label: {
    display: 'inline-block',
    fontWeight: 400,
    fontSize: 14,
    color: COLOR_GRAY__600,
  },
})

UIPassword.propTypes = {
  dynamicStyle: PropTypes.object,
  placeholder: PropTypes.string,
  value: PropTypes.string,
  label: PropTypes.string,
  errorMessage: PropTypes.string,
  message: PropTypes.string,
  onChange: PropTypes.string,
}

export default UIPassword
